@if (!data) {
  <h1 mat-dialog-title>{{ 'SESSIONS.NEW_SESSION_DIALOG.title' | translate }}</h1>
}
@if (data) {
  <h1 mat-dialog-title>{{ 'SESSIONS.FAIR_EDIT_DIALOG.title' | translate }}</h1>
}
<form (submit)="submit()" [formGroup]="form" mat-dialog-content>
  <div class="p-v-2" fxLayoutAlign="center start">
    @if (form.value.mode === 1) {
      <recrewt-image-selector (fileDeleted)="deleteLogo()"
        (fileSelected)="selectLogo($event)"
        [imageUrl]="logoUrl"
        appearance="circle"
        icon="photo"
       />
    }
  </div>
  @if (!data) {
    <p>{{ 'SESSIONS.NEW_SESSION_DIALOG.message' | translate }}</p>
  }
  @if (data) {
    <p>{{ 'SESSIONS.FAIR_EDIT_DIALOG.message' | translate }}</p>
  }
  <mat-form-field appearance="outline" class="block">
    <input formControlName="name" matInput />
    <mat-error>{{ 'SESSIONS.NEW_SESSION_DIALOG.formErrorMessage' | translate }}</mat-error>
    <mat-label>{{ 'SESSIONS.NEW_SESSION_DIALOG.label' | translate }}</mat-label>
  </mat-form-field>
  <p>
    @if (isAdmin && !data) {
      <mat-checkbox
        [control]="form.controls.mode"
        [falseValue]="0"
        [trueValue]="1"
        formControlName="mode"
        >
        {{ 'SESSIONS.NEW_SESSION_DIALOG.fair_check_box_text' | translate }}
      </mat-checkbox>
    }
  </p>
  @if (form.value.mode === 1) {
    @if (!data) {
      <mat-form-field appearance="outline" class="block">
        <input formControlName="pin" matInput />
        <mat-error>{{ 'SESSIONS.NEW_SESSION_DIALOG.pin_error' | translate }}</mat-error>
        <mat-label>{{ 'SESSIONS.NEW_SESSION_DIALOG.pin_title' | translate }}</mat-label>
      </mat-form-field>
    }
    <recrewt-location-selector (click)="$event.stopPropagation()"
      class="width-match-parent"
      error="SESSIONS.NEW_SESSION_DIALOG.fair_location_error"
      formControlName="location"
      label="SESSIONS.NEW_SESSION_DIALOG.fair_location_title"
      type="place"
     />
    <div class="m-b-2">
      <h3>Messetage</h3>
      <recrewt-date-time-range-picker formControlName="dates" />
    </div>
    <div class="m-b-2">
      <mat-checkbox
        [control]="form.controls.jobMatchingEnabled"
        [falseValue]="false"
        [trueValue]="true"
        formControlName="jobMatchingEnabled"
        >
        Zusätzlich Job-Matching aktivieren (Aussteller geben Stellen-Infos ein)
      </mat-checkbox>
    </div>
    @if (form.value.jobMatchingEnabled) {
      <mat-form-field appearance="outline" class="block">
        <mat-label>{{ 'SYNC.targetLabel' | translate }}</mat-label>
        <input formControlName="recrewtSessionRef" matInput [placeholder]="'SYNC.targetPlaceholder' | translate" />
        <mat-hint>{{ 'SYNC.targetHint' | translate }}</mat-hint>
      </mat-form-field>
    }
    @if (form.value.jobMatchingEnabled) {
    <section class="m-b-2" fxLayout="column" fxLayoutGap="12px">
      <h3>Zielgruppen und Angebot</h3>
      <div formArrayName="audience">
        <h4>Zielgruppen:</h4>
        @for (data of Audience; track data; let i = $index) {
          <p>
            <mat-checkbox
              [control]="form.controls.audience.at(i)"
              [falseValue]="null"
              [formControlName]="i"
              [trueValue]="data"
              >
              {{ 'SESSIONS.NEW_SESSION_DIALOG.AUDIENCE.' + data | translate }}
            </mat-checkbox>
          </p>
        }
      </div>
      @if (datasetForm && form.value.audience?.includes(EAudience.GRADUATE)) {
        <div
          [formGroup]="datasetForm"
          >
          <h4>Verfügbare Studienfelder:</h4>
          <recrewt-dynamic-form-table [config]="studyFieldsConfig"
            [showSave]="false"
            class="width-match-parent"
            formControlName="availableStudyFields"
           />
        </div>
      }
      @if (
        datasetForm &&
        (form.value.audience?.includes(EAudience.GRADUATE) ||
        form.value.audience?.includes(EAudience.PROFESSIONAL))
        ) {
        <div
          [formGroup]="datasetForm"
          >
          <h4>Verfügbare Branchen:</h4>
          <recrewt-dynamic-form-table [config]="branchConfig"
            [showSave]="false"
            class="width-match-parent"
            formControlName="branches"
           />
        </div>
      }
      @if (
        datasetForm &&
        (form.value.audience?.includes(EAudience.GRADUATE) ||
        form.value.audience?.includes(EAudience.PROFESSIONAL))
        ) {
        <div
          [formGroup]="datasetForm"
          >
          <h4>Verfügbare Berufsfelder:</h4>
          <recrewt-dynamic-form-table [config]="topicConfig"
            [showSave]="false"
            class="width-match-parent"
            formControlName="topics"
           />
        </div>
      }
    </section>
    }
    <section fxLayout="column" fxLayoutGap="12px">
      <h3>Region</h3>
      <div>
        <mat-select formControlName="locale" placeholder="Region">
          <mat-option value="by">Bayern</mat-option>
          <mat-option value="bw">Baden-Württemberg</mat-option>
          <mat-option value="ns">Niedersachsen</mat-option>
          <mat-option value="sa">Sachsen-Anhalt</mat-option>
        </mat-select>
      </div>
      <div>
        <mat-checkbox
          [control]="form.controls.isProject"
          [falseValue]="false"
          [trueValue]="true"
          formControlName="isProject"
          >
          Handelt es sich um ein Projekt, das KEINE Messe ist?
        </mat-checkbox>
      </div>
      @if (form.value.jobMatchingEnabled) {
      <h3>Erlaubte Eingabefelder auswählen:</h3>
      <div formArrayName="allowBoothData">
        <h4>Zum Messebesuch:</h4>
        @for (data of AllowedBoothData; track data; let i = $index) {
          <p>
            <mat-checkbox
              [control]="form.controls.allowBoothData.at(i)"
              [falseValue]="null"
              [formControlName]="i"
              [trueValue]="data"
              >
              {{ 'SESSIONS.NEW_SESSION_DIALOG.BOOTH.' + data | translate }}
            </mat-checkbox>
          </p>
        }
      </div>
      <div formArrayName="allowCompanyData">
        <h4>Zum Unternehmen:</h4>
        @for (data of AllowedCompanyData; track data; let i = $index) {
          <p>
            <mat-checkbox
              [control]="form.controls.allowCompanyData.at(i)"
              [falseValue]="null"
              [formControlName]="i"
              [trueValue]="data"
              >
              {{ 'SESSIONS.NEW_SESSION_DIALOG.COMPANY.' + data | translate }}
            </mat-checkbox>
          </p>
        }
      </div>
      <div formArrayName="allowJobData">
        <h4>Zu den Stellenangeboten:</h4>
        @for (data of AllowedJobData; track data; let i = $index) {
          <p>
            <mat-checkbox
              [control]="form.controls.allowJobData.at(i)"
              [falseValue]="null"
              [formControlName]="i"
              [trueValue]="data"
              >
              {{ 'SESSIONS.NEW_SESSION_DIALOG.JOB.' + data | translate }}
            </mat-checkbox>
          </p>
        }
      </div>
      }
    </section>
  }
</form>

<div fxLayoutAlign="end center" mat-dialog-actions>
  <div>
    <button (click)="onNoClick()" mat-button>{{ 'COMMON.cancel' | translate }}</button>
    <button (click)="submit()" [disabled]="!isFormValid" color="accent" mat-flat-button>
      {{ 'COMMON.confirm' | translate }}
    </button>
  </div>
</div>
